import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';
import { NavLeft } from '../sidebar-navigation';
import { NAVLEFTITEM } from '../sidebar-navigation-constants';
import { RoleAuthorizationService } from '../../../../services/role-authorization.service';
import { AzureLoginService } from '../../../../services/azure-login.service';
import {
  IRoleAuthorizationService,
  AuthorizationType,
} from '../../../../interfaces/role-authorization.interface';
import { environment } from 'src/environments/environment';
import { Apollo } from 'apollo-angular';
import { CrmGraphql } from 'src/app/modules/crm/shared/constants/graphql-constants';

@Component({
  standalone: false,
  selector: 'sidebar-left-navigation',
  templateUrl: 'sidebar-left-navigation.template.html',
  styleUrls: ['sidebar-left-navigation.scss'],
})
export class SidebarLeftComponent implements OnInit, OnDestroy {
  @Input() public myCallback: any;
  navleftitem = NAVLEFTITEM;
  selectedNavleft: NavLeft;
  authDetails: IRoleAuthorizationService;
  buildNumber = `v${environment.buildNumber}`;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private roleService: RoleAuthorizationService,
    private azureService: AzureLoginService,
    private apollo: Apollo,
  ) {}

  ngOnInit() {
    this.azureService.rolePermissionsUpdated$
      .pipe(startWith(undefined), takeUntil(this.destroy$))
      .subscribe(() => this.applyNavAuthorization());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyNavAuthorization(): void {
    this.authDetails = {
      authorizationType: AuthorizationType.LeftPanel,
      component: SidebarLeftComponent,
      componentName: 'SidebarLeftComponent',
      generalArray: JSON.parse(JSON.stringify(NAVLEFTITEM)),
    };
    this.navleftitem = Object.assign(this.roleService.applyAuthorization(this.authDetails));
  }

  onSelect(navleft: NavLeft): void {
    this.selectedNavleft = navleft;
    if (this.myCallback && typeof this.myCallback === 'function') {
      this.myCallback(navleft.id);
    }
  }

  public async refresh() {
    const client = this.apollo.use(CrmGraphql.NameSpace).client;
    try {
      await client.resetStore();
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      if (message.includes('Store reset while query was in flight')) {
        return;
      }
      throw err;
    }
  }
}
